(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fk-quick-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fk-quick-set')) {
  class FkQuickSet extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.status = this.querySelector('[data-status]');
      this.button = this.querySelector('[data-add]');
      this.button.addEventListener('click', () => this.add());
      try {
        const response = await fetch(this.dataset.source, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const model = Array.from(doc.querySelectorAll('[data-fk-model]')).find((item) => item.dataset.productHandle === this.dataset.handle);
        const catalog = doc.querySelector('[data-fk-strap-catalog]');
        if (!model || !catalog) throw new Error();
        const variants = JSON.parse(model.querySelector('[data-fk-variants]').textContent);
        const straps = JSON.parse(catalog.textContent);
        const recommendationCatalog = doc.querySelector('[data-fk-recommendations]');
        const recommendations = recommendationCatalog ? JSON.parse(recommendationCatalog.textContent) : [];
        const preference = recommendations.find((item) => item.handle === this.dataset.handle);
        const selection = this.choose(variants, straps, model.dataset.defaultMetal, preference);
        if (!selection) throw new Error();
        this.selection = selection;
        this.title = model.dataset.productTitle;
        const { variant, strap, metal, extra } = selection;
        const bagImage = this.querySelector('[data-bag-image]');
        bagImage.src = (preference && preference.image) || (variant.featured_image && variant.featured_image.src) || model.dataset.productImage;
        if (preference && preference.image) {
          bagImage.alt = [this.title, strap.title, metal].join(' · ');
          this.querySelector('[data-image-note]').textContent = this.copy.combinationNote;
        }
        const strapImage = this.querySelector('[data-strap-image]');
        if (strap.image) strapImage.src = strap.image;
        else strapImage.hidden = true;
        strapImage.alt = strap.title;
        this.querySelector('[data-strap-title]').textContent = strap.title + ' · ' + strap.variantTitle;
        this.querySelector('[data-details]').textContent = metal + ' · ' + (extra === this.copy.withPocket ? this.copy.withPocketLabel : this.copy.withoutPocketLabel);
        const locale = document.documentElement.lang || 'de-DE';
        const amount = (Number(variant.price) + Number(strap.price)) / 100;
        const total = new Intl.NumberFormat(locale, { style: 'currency', currency: this.dataset.currency }).format(amount);
        this.querySelector('[data-total]').textContent = locale.toLowerCase().startsWith('de') && this.dataset.currency === 'EUR'
          ? '€' + new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
          : total;
        const link = new URL(this.querySelector('[data-adjust]').href);
        link.searchParams.set('ausstattung', variant.id);
        link.searchParams.set('gurt', strap.id);
        this.querySelector('[data-adjust]').href = link.href;
        this.querySelector('[data-content]').hidden = false;
        this.status.textContent = '';
      } catch (error) {
        this.status.textContent = this.copy.fallback;
      }
    }
    choose(variants, straps, defaultMetal, preference) {
      const hasPocket = (variant) => /innentasche/i.test(variant.title) && !/ohne\s+innentasche/i.test(variant.title);
      let candidates = variants.filter((variant) => variant.available && /ohne\s+gurt/i.test(variant.title) && !/^(s|m|l|xl)\s*[|/]/i.test(variant.title));
      if (preference) {
        candidates = candidates.filter((variant) => hasPocket(variant) === (preference.pocket !== 'without'));
      } else {
        candidates = candidates.filter(hasPocket).concat(candidates.filter((variant) => !hasPocket(variant)));
      }
      for (const variant of candidates) {
        const part = variant.title.split(/\s*[|/]\s*/).find((value) => !/gurt/i.test(value) && /(silber|gold)/i.test(value));
        const metal = part ? (/silber/i.test(part) ? 'Silberfarben' : 'Goldfarben') : defaultMetal;
        if (preference && preference.metal && preference.metal !== 'auto' && preference.metal !== metal) continue;
        const strap = straps.find((item) => {
          if (item.metal !== metal) return false;
          if (preference && preference.strapProductId && String(item.productId) !== String(preference.strapProductId)) return false;
          if (preference && preference.strapVariant && String(item.variantTitle).trim().toLocaleLowerCase('de-DE') !== preference.strapVariant.trim().toLocaleLowerCase('de-DE')) return false;
          return true;
        });
        if (!strap) continue;
        const extra = hasPocket(variant) ? this.copy.withPocket : this.copy.withoutPocket;
        return { variant, strap, metal, extra };
      }
      return null;
    }
    async add() {
      if (this.adding || !this.selection) return;
      this.adding = true;
      this.button.disabled = true;
      this.button.textContent = this.copy.busy;
      this.status.textContent = '';
      const { variant, strap, metal, extra } = this.selection;
      const id = 'fk-' + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
      const shared = { _fk_config_id: id, Metall: metal, Innentasche: extra, Gurt: strap.title };
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: variant.id, quantity: 1, properties: { ...shared, Konfiguration: 'Frau Kathl Mix & Match', _fk_role: 'Tasche' } },
            { id: strap.id, quantity: 1, properties: { ...shared, 'Zu Tasche': this.title, _fk_role: 'Gurt' } }
          ] })
        });
        if (!response.ok) {
          this.status.textContent = this.copy.error;
          this.querySelector('[data-cart]').hidden = false;
          this.button.textContent = this.copy.add;
          return;
        }
        window.location.href = this.dataset.cartUrl;
      } catch (error) {
        this.status.textContent = this.copy.network;
        this.querySelector('[data-cart]').hidden = false;
        this.button.textContent = this.copy.add;
      }
    }
  }
  customElements.define('fk-quick-set', FkQuickSet);
}
  } catch(e) { console.error(e); }
})();

})();
